import './ReviewPages.scss';

import React from 'react';
import {Button, Container, Spinner} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";

import {useDispatch} from "react-redux";

import {AppDispatch} from "../../../services/store/store";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import ReviewStar from "../components/ReviewStar";
import {
    handleRatingUpdated,
    handleReviewMessageUpdated,
    handleToggleAttribute,
    handleToggleShareComment
} from "../../../services/store/reducers/postRound/slice";
import Avatar from "../../../components/Avatar";
import ReviewAttribute from "../components/ReviewAttribute";
import {useDispatchedValue} from "../../../hooks/useDispatchedValue";
import TickIcon from "../../../icons/TickIcon";
import ErrorText from "../../../components/ErrorText";
import ArrowLeftIcon from "../../../icons/ArrowLeftIcon";
import {IconSize} from "../../../services/IconConstants";
import {useNavigate} from "react-router-dom";
import {submitReview} from "../../../services/store/reducers/postRound/async_actions";
import {buildUrl, REVIEW_CONFIRMED} from "../../../services/PageUtils";

interface Props {

}

const ReviewCaddie = ({}: Props) => {

    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const { errMsg, session } = handicaddieSelector(state => state.postRound)

    const { setValue, dispatchValue, processing } = useDispatchedValue((comment) => {
        dispatch(handleReviewMessageUpdated(comment))
    })

    const submit = () => {
        dispatch(submitReview())
            .then(() => {
                navigate(buildUrl(REVIEW_CONFIRMED));
            })
    }

    if (!session) {
        return (<>
            <Container>
                <div className={"findYourCaddie_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div onClick={() => navigate(-1)}>
                    <ArrowLeftIcon
                        size={IconSize.xl}
                        className={"reviewCaddie_goBackArrow"}/>
                </div>

                <Spinner/>
            </Container>
        </>)
    }

    const { review, caddie } = session;

    if (!caddie) {
        return (
            <Container>
                <div className={"findYourCaddie_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div onClick={() => navigate(-1)}>
                    <ArrowLeftIcon
                        size={IconSize.xl}
                        className={"reviewCaddie_goBackArrow"}/>
                </div>

                <div>
                    <span className={"heading"}>Review Your Caddie</span>
                </div>

                <Spinner/>
            </Container>
        )
    }

    const caddieId = caddie.id;
    const userId = caddie.userId;
    const caddieName = caddie.name;

    return (
        <Container>
            <div className={"findYourCaddie_logoContainer"}>
                <HandicaddieLogo size={'lg'} />
            </div>

            {/*<GoBackArrow onPress={navigation.goBack} style={styles.goBackArrow} />*/}

            <div onClick={() => navigate(-1)}>
                <ArrowLeftIcon
                    size={IconSize.xl}
                    className={"reviewCaddie_goBackArrow"} />
            </div>

            <span className={"heading reviewCaddie_container"}>Review Your Caddie</span>

            <div className={"reviewCaddie_caddieInformationContainer"}>
                <div className={"reviewCaddie_caddieContainer"}>
                    <Avatar size={'s'} user={userId}/>
                    <span className={"reviewCaddie_caddieName"}>{caddieName}</span>
                </div>
            </div>

            <div className={"reviewCaddie_line"}/>

            <div className={"reviewCaddie_clickableIconRow reviewCaddie_stars"}>
                {[...Array(5)].map((_, idx) => {
                    return <ReviewStar
                        key={idx}
                        active={review.rating > 0 && review.rating >= (idx + 1)}
                        onPress={() => dispatch(handleRatingUpdated(idx + 1))}
                    />
                })}
            </div>

            <div className={"reviewCaddie_line"}/>

            <div className={"reviewCaddie_formQuestionContainer"}>
                <span>What did you like most about your caddie?</span>
                <div className={"reviewCaddie_clickableIconRow"}>
                    {['Knowledge', 'Punctuality', 'Productivity', 'Politeness'].map(attr => {
                        return <ReviewAttribute
                            key={attr}
                            name={attr}
                            activeAttributes={review.attributes}
                            onPress={() => dispatch(handleToggleAttribute(attr))}/>
                    })}
                </div>
            </div>

            <div className={"reviewCaddie_line"}/>

            <div className={"reviewCaddie_formQuestionContainer"}>
                <span className={"reviewCaddie_addCommentLabel"}>Add a comment to your review:</span>
                <textarea
                    rows={5}
                    placeholder="Leave a comment..."
                    id="reviewComment"
                    className={"reviewCaddie_txtInput"}
                    onChange={(e) => setValue(e.target.value)}
                    onSubmit={dispatchValue}
                />
                <div className={"reviewCaddie_shareContainer"} onClick={() => dispatch(handleToggleShareComment())}>
                    {review?.shareComment && <TickIcon size={"2em"} className={"reviewCaddie_shareCheckbox"} />}
                    {!review?.shareComment && <div className={"reviewCaddie_shareCheckbox reviewCaddie_shareCheckboxUnchecked"} />}

                    <span className={"reviewCaddie_shareTxt"}>Share your comment with caddie.</span>
                </div>
            </div>

            {errMsg && <ErrorText>{errMsg}</ErrorText>}

            <Button className={"reviewCaddie_bottomButton"} onClick={() => {
                dispatchValue()
                submit()
            }}>
                <span className={"reviewCaddie_btnText"}>SAVE REVIEW</span>
            </Button>
        </Container>
    )
}

export default ReviewCaddie;